export default {
  'releaseBillToPay.list.header.code': 'Code',
  'releaseBillToPay.list.header.installmentTag': 'Tag',
  'releaseBillToPay.list.header.companies': 'Company',
  'releaseBillToPay.list.header.documentNumber': 'Document Number',
  'releaseBillToPay.list.header.creditor': 'Creditor',
  'releaseBillToPay.list.header.description': 'Description',
  'releaseBillToPay.list.header.documentType': 'Doc. Type',
  'releaseBillToPay.list.header.dueDate': 'Due Date',
  'releaseBillToPay.list.header.situation': 'Situation',
  'releaseBillToPay.list.header.value': 'Value',
  'releaseBillToPay.list.header.amountPaid': 'Valor Pago',
  'releaseBillToPay.list.header.amountReceivable': 'Amount Receivable',
  'releaseBillToPay.list.header.actions': 'Action',

  'releaseBillToReceiver.searchBar.create': 'Create New Account Payable',
  'releaseBillToReceiver.searchBar.settleInstallments':
    'Settle Selected Installments',

  'release.form.company': 'Company',
  'release.form.debtor': 'Debtor',
  'release.form.customer': 'Customer',
  'release.form.insurer': 'Insurer',
  'release.form.planAccount': 'Plan Account',
  'release.form.description': 'Description',
  'release.form.documentNumber': 'Document Number',
  'release.form.split': 'Split',
  'release.form.documentType': 'Document Type',
  'release.form.issueDate': 'Issue Date',
  'release.form.dueDate': 'Due Date',
  'release.form.payDay': 'Payday',
  'release.form.costCenter': 'Cost Center',
  'release.form.bankAccount': 'Bank Account',
  'release.form.value': '(US$) Value',
  'release.form.increaseAndDecrease': '(US$) Incr./Decr.',
  'release.form.increase': '(R$) Incrise',
  'release.form.discount': '(R$) Discount',
  'release.form.netValue': '(US$) Net Value',
  'release.form.observation': 'Observation',
};
